import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MenuButton from "../../../components/MenuButton/MenuButton";
import "../../../styles/globals.css";
import "./MyPageMenuPage.css";

/**
 * マイページ画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function MyPageMenuPage() {
  const navigate = useNavigate();

  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {}, []);

  return (
    <div className="mypage-menu">
      <div className="main-area">
        <div className="title">マイページ</div>
        <div className="detail"></div>
        <div className="detail">アカウント設定</div>
        <div className="menu-buttons">
          <MenuButton
            key={1}
            className="menu-button"
            buttonLabel={"個人情報変更"}
            onClick={() => navigate("/mypage/user-setting")}
          />
          <MenuButton
            key={2}
            className="menu-button"
            buttonLabel={"家族設定"}
            onClick={() => navigate("/mypage/family-list")}
          />
          <MenuButton
            key={3}
            className="menu-button"
            buttonLabel={"メールアドレス変更"}
            onClick={() => navigate("/mypage/mail-setting")}
          />
          <MenuButton
            key={4}
            className="menu-button"
            buttonLabel={"パスワード変更"}
            onClick={() => navigate("/mypage/password-setting")}
          />
          <MenuButton
            key={5}
            className="menu-button"
            buttonLabel={"受診済医療機関"}
            onClick={() => navigate("/mypage/medical-institution-list")}
          />
        </div>
        <div className="detail">カスタマーサービス</div>

        <div className="menu-buttons">
          <MenuButton
            key={1}
            className="menu-button"
            buttonLabel={"よくある質問"}
            onClick={() => navigate("/mypage/faq-list")}
          />
          <MenuButton
            key={2}
            className="menu-button"
            buttonLabel={"退会手続き"}
            onClick={() => navigate("/mypage/unsubscribe")}
          />
        </div>
      </div>
    </div>
  );
}

export default MyPageMenuPage;
